import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const o = a((e, r) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: r,
    ...e,
    image: (c) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...c,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3624",
              width: 10,
              height: 16,
              x: 4,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M12.52 2.75c-.41 0-.75.34-.75.75v7.3c0 3.35-2.17 3.71-3.1 3.71-1.53 0-3.17-.91-3.17-3.46V3.49c0-.74.36-1.99 1.71-1.99s2.13.57 2.13 3.51v5.82c0 .45-.09 1.2-.68 1.2-.17 0-.71 0-.71-1.07V3.4c0-.41-.34-.75-.75-.75s-.74.34-.74.75v7.56c0 1.9 1.19 2.57 2.21 2.57 1.08 0 2.18-.84 2.18-2.7V5.01c0-1.37 0-5.01-3.63-5.01C5.1 0 4 1.75 4 3.49v7.55C4 14.46 6.34 16 8.67 16c2.12 0 4.6-1.36 4.6-5.21V3.5c0-.42-.34-.75-.75-.75"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3624)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyPaperclipIcon";
export {
  o as AgencyPaperclipIcon,
  o as default
};
//# sourceMappingURL=index.js.map
